import { drawerSX, drawerThemeSX } from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import { isB2BStore, useSettings } from '@/data/Settings';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
	Box,
	CardMedia,
	Divider,
	SwipeableDrawer,
	SxProps,
	Theme,
	Typography,
	useTheme,
} from '@mui/material';
import { FC, useMemo } from 'react';

type Tvariant =
	| 'menu'
	| 'stores'
	| 'cart'
	| 'facet'
	| 'especificaciones-tecnicas'
	| 'disponibilidad'
	| 'msi'
	| 'delivery'
	| 'bopis'
	| 'informacion-adicional'
	| 'order'
	| 'orderResume'
	| 'instalation'
	| 'promotions'
	| 'payment-instructions'
	| 'instructions-oxxo'
	| 'seguimiento-entrega'
	| 'checkout-profiles'
	| 'mini-sign-in'
	| 'super-sku'
	| 'kit-specifications'
	| 'wishList-drawer'
	| 'buy-by-color'
	| 'giftProduct'
	| 'saveMore'
	| 'checkout';

interface IDrawerProps {
	isOpen: boolean;
	children?: JSX.Element[] | JSX.Element;
	setOpenDrawer: (boolean: boolean) => void;
	variant?: Tvariant;
	hideCategories?: () => void;
	title?: string;
	showMemoized?: boolean;
	currentStore?: any;
	setStateSelected?: (any: any) => void;
	disableSwipeToOpen?: boolean;
}
interface IHeaderMenu {
	variant: string;
	setOpenDrawer: (boolean: boolean) => void;
	hideCategories?: () => void;
	title?: string;
	currentStore: any;
	setStateSelected: any;
}
const HeaderMenu = ({
	variant,
	setOpenDrawer,
	hideCategories,
	currentStore,
	setStateSelected,
	...props
}: IHeaderMenu) => {
	const closeDrawer = () => {
		if (currentStore && setStateSelected) {
			setStateSelected(currentStore.currentStore.stateId);
		}
		setOpenDrawer(false);
		if (hideCategories) {
			setTimeout(() => {
				hideCategories();
			}, 200);
		}
	};
	const theme = useTheme();
	const { settings } = useSettings();
	const isB2B = isB2BStore(settings);

	/**
	 * No agregar más titulos de drawer de esta manera ya que el código se vuelve poco sostenible
	 * */
	return (
		<>
			<Box
				sx={{
					...drawerSX.headerMenu,
					justifyContent: variant === 'instructions-oxxo' ? 'left' : '',
				}}
			>
				<Box
					sx={{
						...drawerSX.iconContBase,
						...(variant === 'stores' ||
						variant === 'facet' ||
						variant === 'menu' ||
						variant === 'seguimiento-entrega'
							? { textAlign: 'left' }
							: { textAlign: 'right' }),
					}}
				>
					<HighlightOffIcon
						onClick={closeDrawer}
						sx={
							{
								...(variant === 'checkout' ? drawerSX.iconContCheckout : drawerSX.closeIcon),
							} as SxProps<Theme>
						}
					/>
				</Box>
				{variant === 'menu' ? (
					<CardMedia
						image={isB2B ? `/HDMX/images/TheHomeDepotPro.svg` : `/HDMX/images/TheHomeDepot.svg`}
						sx={isB2B ? drawerSX.drawerHomedepotPrologo : {}}
						title="home depot logo"
						component="img"
					/>
				) : null}
				<Typography
					variant={variant === 'promotions' ? 'body2' : 'body1'}
					sx={drawerThemeSX.headerMenuText(theme)}
				>
					{props.title ? props.title : <> useTitleMap(variant) </>}
				</Typography>
			</Box>
			<Box sx={drawerSX.basicSeparator}>
				<Divider />
			</Box>
		</>
	);
};

export const SwipeableDrawerHDM: FC<IDrawerProps> = ({
	isOpen,
	setOpenDrawer,
	children,
	variant = 'menu',
	hideCategories,
	showMemoized,
	currentStore,
	setStateSelected,
	...props
}) => {
	const { settings } = useSettings();
	const isB2B = isB2BStore(settings);

	const disableSwipeToOpen = true;

	const showMemoizedChildren = showMemoized;
	const initMemoizedChildren = useMemo(() => children, [children]);

	const updatedMemoizedChildren = useMemo(() => children, [children]);

	const closeDrawer = () => {
		if (currentStore && setStateSelected) {
			setStateSelected(currentStore.currentStore.stateId);
		}

		if (variant === 'menu' && hideCategories) {
			setTimeout(() => {
				hideCategories();
			}, 200);
		}
		setOpenDrawer(false);
	};
	let idContainer = '';
	switch (variant) {
		case 'stores':
			idContainer = 'storeSelectorList';
			break;
		case 'checkout-profiles':
			idContainer = 'checkoutProfileSelectorList';
			break;
		case 'menu':
			idContainer = 'mainMenu';
			break;
	}

	return (
		<SwipeableDrawer
			anchor={
				variant === 'stores' ||
				variant === 'facet' ||
				variant === 'menu' ||
				variant === 'seguimiento-entrega'
					? 'left'
					: variant === 'orderResume'
					? 'bottom'
					: 'right'
			}
			open={isOpen}
			sx={drawerSX.drawer}
			onOpen={() => setOpenDrawer(true)}
			onClose={closeDrawer}
			disableSwipeToOpen={disableSwipeToOpen}
			disableEnforceFocus
		>
			{variant !== 'orderResume' ? (
				<>
					{variant === 'menu' ? (
						<HeaderMenu
							variant={'menu'}
							setOpenDrawer={setOpenDrawer}
							hideCategories={hideCategories}
							title={props.title}
							currentStore={currentStore}
							setStateSelected={setStateSelected}
						/>
					) : null}
					{variant !== 'menu' ? (
						<HeaderMenu
							currentStore={currentStore}
							setStateSelected={setStateSelected}
							variant={variant}
							setOpenDrawer={setOpenDrawer}
							title={props.title}
						/>
					) : null}
				</>
			) : null}

			<Box
				id={idContainer}
				sx={{
					...drawerSX.drawerContent,
					...(variant === 'facet' ? { position: 'fixed' } : {}),
				}}
			>
				{showMemoizedChildren ? initMemoizedChildren : updatedMemoizedChildren}
			</Box>
		</SwipeableDrawer>
	);
};
